module.exports = {"path":"/404.html","layout":"page","body":"<img src=\"hmm.gif\" width=\"300\">\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 506
// module chunks = 0